export default __webpack_public_path__ + "static/media/logoCoinLab.8a9f0138.png";